export enum AnalyticsEvent {
  // ===== Навигация и UI =====
  /** Клик по мини-календарю (выбор даты) */
  clickMiniCalendar = 'click_mini_calendar',
  /** Скрытие выходных в режиме недели */
  hideWeekends = 'hide_weekends',
  /** Показ выходных в режиме недели */
  showWeekends = 'show_weekends',
  /** Открытие drawer с деталями задачи/лога */
  openDetailDrawer = 'open_detail_drawer',
  /** Переключение на предыдущую/следующую неделю */
  switchWeek = 'switch_week',
  /** Переключение на предыдущий/следующий месяц */
  switchMonth = 'switch_month',

  // ===== Работа с логами =====
  /** Изменение цвета лога/очереди */
  changeLogColor = 'change_log_color',

  // ===== Работа с задачами =====
  /** Копирование названия задачи */
  copyTaskName = 'copy_task_name',
  /** Переход к задаче в Трекере */
  goToTask = 'go_to_task',

  // ===== Фильтры и пользователи =====
  /** Выбор пользователя (админ смотрит чужие логи) */
  selectUser = 'select_user',
  /** Применение фильтра */
  applyFilter = 'apply_filter',
  /** Добавление пользователя в избранное */
  addUserToFavorites = 'add_user_to_favorites',
  /** Создание лога из избранных задач */
  createLogFromFavorites = 'create_log_from_favorites',

  // ===== Статистика и модалки =====
  /** Открытие модалки статистики */
  openStatsModal = 'open_stats_modal',

  // ===== UX-фичи =====
  /** Использование горячих клавиш */
  useHotkeys = 'use_hotkeys',
  /** Использование кнопок быстрого ввода времени (15м, 30м, 1ч...) */
  useQuickInputButtons = 'use_quick_input_buttons',
  /** Клик "Добавить дату" в форме лога */
  clickAddDate = 'click_add_date',

  // ===== CalDAV интеграция =====
  /** Подключение CalDAV */
  caldavConnect = 'caldav_connect',
  /** Отключение CalDAV */
  caldavDisconnect = 'caldav_disconnect',
  /** Синхронизация календарей CalDAV */
  caldavSync = 'caldav_sync',
  /** Изменение выбора календарей */
  caldavChangeCalendars = 'caldav_change_calendars',
  /** Создание лога из события календаря */
  caldavCreateLogFromEvent = 'caldav_create_log_from_event',

  // ===== Секундомеры =====
  /** Создание секундомера */
  stopwatchCreate = 'stopwatch_create',
  /** Запуск секундомера */
  stopwatchStart = 'stopwatch_start',
  /** Пауза секундомера */
  stopwatchPause = 'stopwatch_pause',
  /** Остановка секундомера */
  stopwatchFinish = 'stopwatch_finish',
  /** Удаление секундомера */
  stopwatchDelete = 'stopwatch_delete',
  /** Публикация секундомера как лога */
  stopwatchPublish = 'stopwatch_publish',

  // ===== Черновики =====
  /** Создание черновика */
  draftCreate = 'draft_create',
  /** Редактирование черновика */
  draftEdit = 'draft_edit',
  /** Удаление черновика */
  draftDelete = 'draft_delete',
  /** Публикация черновика как лога */
  draftPublish = 'draft_publish',
  /** Массовая публикация черновиков */
  draftPublishBulk = 'draft_publish_bulk',

  // ===== Настройки =====
  /** Изменение сортировки таблицы */
  settingsChangeSortOrder = 'settings_change_sort_order',
  /** Изменение режима кнопок времени (прибавлять/заменять) */
  settingsChangeTimeButtonsMode = 'settings_change_time_buttons_mode',

  // ===== Обратная связь =====
  /** Клик по кнопке баг-репорта */
  clickBugReport = 'click_bug_report',
}

export enum ClickSource {
  month = 'month',
  week = 'week',
}

declare global {
  function ym(counter: number, type: 'hit', url: string): void;
  function ym(counter: number, type: 'reachGoal', event: AnalyticsEvent, params?: object): void;

  interface Window {
    YA_METRIKA_COUNTER: any;
    ym?: typeof ym;
  }
}
